export const environment = {
	production: true,
	appUrl: 'https://payroll.hris.ts.exist.com.ph',
	authUrl: 'https://keycloak.hris.ts.exist.com.ph',
	recruitmentUrl: 'https://recruitment.hris.ts.exist.com.ph'
};
